var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.path
    ? _c("div", { class: _vm.loaderClass, attrs: { id: "preload" } }, [
        _c(
          "div",
          {
            staticClass: "row h-100 justify-content-center align-items-center",
          },
          [
            _c("div", { staticClass: "col-12 text-center" }, [
              !_vm.overlay
                ? _c("div", { staticClass: "ld ld-ring ld-spin-fast huge" })
                : _vm._e(),
              _vm._v(" "),
              _vm.error
                ? _c("div", { staticClass: "preload-error-icon" }, [
                    _c("i", {
                      staticClass: "fa fa-exclamation-circle",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h6", { staticClass: "mt-3 font-weight-s-bold" }, [
                _vm._v("\n        " + _vm._s(_vm.text) + "\n      "),
              ]),
            ]),
          ]
        ),
      ])
    : _c("div", { class: _vm.loaderClass, attrs: { id: "preload" } }, [
        _c("div", { staticClass: "row h-100 align-items-center" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            !_vm.overlay
              ? _c("h6", { staticClass: "mt-5 pt-5 font-weight-s-bold" }, [
                  _vm._v("\n        " + _vm._s(_vm.text) + "\n      "),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }